export const LOGO_MAX_WIDTH = 92;
export const LOGO_HEIGHT = 40;
export const SEARCH_WIDTHS = ['100%', 300, 300, 362];
export const CONTAINER_PADDING_X = ['sp_16', 'sp_24', 'sp_48', 'sp_64'];
export const CONTAINER_PADDING_Y = ['sp_16', null, null, 'sp_24'];
export const PADDING_OFFSET = 120;
export const CONTAINER_MAX_WIDTH = 1600;
export const MOBILE_VIEW_SCROLL_OFFSET = 110;
export const MINIMAL_SEARCH_CONTAINER_SIZE = 42;

export const NAV_Z_INDEX = 1000;
export const NAV_SEARCH_Z_INDEX = 1002;

export const DEFAULT_STICKY_TOP_PX = -1;

export const SCROLL_DIRECTIONS = {
  UP: 'UP',
  DOWN: 'DOWN',
} as const;
